<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rulesOrgProvince"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>

            <div class="lg:mb-2" v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div class="flex justify-between items-center">
                <div class="flex-1">
                  <AccessibleElSelect
                    v-model="form.clienteId"
                    prop="clienteId"
                    :options="clientesForAccessibleSelect"
                    :isDisabled="!isCreate"
                    id-prefix="orgprovince"
                  >
                    <template slot="label">
                      <base-obligatory-icon v-if="isCreate"/>
                      {{$t('app.client')}}
                    </template>
                  </AccessibleElSelect>
                </div>
                <base-button
                  v-if="!isCreate"
                  class="ml-4"
                  mode="primary"
                  :text="$t('app.detail')"
                  @click.prevent.stop="goDetailClient"
                  :loading="isGeneralLoading"
                />
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('organismoprovincia.CodigoOrganismo')}}
                  <el-form-item prop="CodigoOrganismo">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.CodigoOrganismo"
                      maxlength='250'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('organismoprovincia.NombreOrganismo')}}
                  <el-form-item prop="NombreOrganismo">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.NombreOrganismo"
                      maxlength='500'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('organismoprovincia.CodigoProvincia')}}
                  <el-form-item prop="CodigoProvincia">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.CodigoProvincia"
                      maxlength='250'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('organismoprovincia.NombreProvincia')}}
                  <el-form-item prop="NombreProvincia">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.NombreProvincia"
                      maxlength='500'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.Organismo"
                prop="Organismo"
                :options="organismosForAccessibleSelect"
                :isMultiple="true"
                clearable
                :remote="true"
                :remoteMethod="remoteOrganismos"
                popperClass="wrap-select-popover"
                :loading="loadingOrganismos"
                id-prefix="orgprovince"
              >
                <template slot="label">
                  <div class="flex items-center gap-x-2">
                    {{$t('app.organismo_zc')}}
                    <base-tooltip-icon size="sm" :content="'Escribe para iniciar la búsqueda'"/>
                  </div>
                </template>
              </AccessibleElSelect>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="save"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { i18n } from '@/i18n'

import { getClients } from '@/services/clients/getClients'

import { getOrgProvince } from '@/services/configurations/rules/getOrgProvince'
import { newOrgProvince } from '@/services/configurations/rules/newOrgProvince'
import { updateOrgProvince } from '@/services/configurations/rules/updateOrgProvince'

import { getOrganismosAll } from '@/services/configurations/getOrganismosAll'

export default {
  /* eslint-disable camelcase */
  name: 'org-province-detail',
  components: {
    DetailLayout,
    AccessibleElSelect,
  },
  data: function () {
    return {
      isMounted: false,
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      searchView: false,
      activeName: 'es',
      localUserId: null,
      header: {
        title: 'DETALLE DE ORGANISMO / PROVINCIA',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/orgprovinces'
      },
      firstLoad: true,
      form: this.getDefaultForm(),
      clientes: [],
      organismos: [],
      loadingOrganismos: false,
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      rulesOrgProvince: {
        clienteId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        CodigoOrganismo: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        NombreOrganismo: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        CodigoProvincia: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        NombreProvincia: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
      },
    }
  },
  computed: {
    empresaFilter () {
      return this.isCreate ? this.$store.getters['orgprovinces/getMasterFilters']?.empresa?.value || null : null
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isSelectClientEmpty: function () {
      return this.form.clienteId === null || this.form.clienteId === undefined || this.form.clienteId === ''
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({
        id: cliente.IdEmpresa,
        value: cliente.IdEmpresa,
        name: cliente.Nombre
      }))
    },
    organismosForAccessibleSelect () {
      return this.organismos.map(org => ({
        id: org.id,
        value: org.id,
        name: org.label
      }))
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
  },
  created: async function () {
    const breadcrumbs = []

    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
      if (this.isCreate) this.preSelectClient(this.form, 'clienteId')
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    }
    breadcrumbs.push({ path: 'configurations/orgprovinces', name: this.$i18n.t('app.orgprovinces') })

    if (!this.isCreate) {
      await this.downloadData(this.id)
      breadcrumbs.push({ path: '', name: `${this.form.NombreOrganismo} - ${this.form.NombreProvincia}` })
      this.$store.commit('app/setheaderBreadCrumb', `${this.form.NombreOrganismo} - ${this.form.NombreProvincia}`)
    } else {
      breadcrumbs.push({
        path: '',
        name: this.$i18n.t('organismoprovincia.new')
      })
    }
    this.header.breadcrumb = breadcrumbs

    this.$store.commit('setIsLoading', false)
  },
  mounted () {
    this.isMounted = true
    this.resetControlFormChanges()
  },
  methods: {
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    getDefaultForm: function () {
      return {
        id: 0,
        clienteId: null,
        CodigoOrganismo: '',
        NombreOrganismo: '',
        CodigoProvincia: '',
        NombreProvincia: '',
        Organismo: null,
      }
    },
    remoteOrganismos: async function (query) {
      this.organismos = []
      if (query !== '' && this.loadingOrganismos === false && query.length > 2) {
        this.loadingOrganismos = true
        setTimeout(async () => {
          const organismos = await getOrganismosAll({ filtro: query })
          if (organismos.blnError === true) {
            this.doFeedback(organismos.msgError + ' [Código de error: ' + organismos.codError + ']')
          }
          if (organismos.DatosOrganismos !== undefined && organismos.DatosOrganismos?.length > 0) {
            let organismosMatch = []
            if (organismos.DatosOrganismos.length > 200) {
              organismosMatch = organismos.DatosOrganismos.filter(x => x.CIF.toUpperCase() === query.toUpperCase() || x.Nombre.toUpperCase() === query.toUpperCase())
              if (organismosMatch.length > 0) {
                this.doFeedback('Se han encontrado resultados coincidentes, pero se ha excedido el límite para los que contienen la búsqueda. Si el resultado esperado no aparece, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              } else {
                this.doFeedback('Se ha excedido el límite de resultados en la búsqueda. Por favor, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              }
            } else {
              organismosMatch = organismos.DatosOrganismos
            }
            organismosMatch.forEach(element => {
              this.organismos.push(
                { 
                  id: element.idOrganismo, 
                  value: element.Nombre,
                  label: this.formatNombreOrg(element),
                }
              )
            })
          }
          this.loadingOrganismos = false
        }, 200)
      }
    },
    formatNombreOrg (element) {
      return element.Nombre + ' - ' + element.CIF
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      if (this.isCreate) {
        this.newOrgProvinceHandler(formName)
      } else {
        this.updateOrgProvinceHandler(formName)
      }
    },
    newOrgProvinceHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            idCliente: this.form.clienteId,
            CodigoOrganismo: this.form.CodigoOrganismo,
            NombreOrganismo: this.form.NombreOrganismo,
            CodigoProvincia: this.form.CodigoProvincia,
            NombreProvincia: this.form.NombreProvincia,
            idOrganismos: this.form.Organismo,
          }
          const response = await newOrgProvince(params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Datos guardados correctamente', 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
            if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
              this.preSelectClient(this.form, 'clienteId')
            }
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    updateOrgProvinceHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            idOrganismoProvincia: this.id,
            idCliente: this.form.clienteId,
            CodigoOrganismo: this.form.CodigoOrganismo,
            NombreOrganismo: this.form.NombreOrganismo,
            CodigoProvincia: this.form.CodigoProvincia,
            NombreProvincia: this.form.NombreProvincia,
            idOrganismos: this.form.Organismo,
          }
          const response = await updateOrgProvince(params)
          if (response.blnError === false) {
            this.doFeedback('Datos guardados correctamente', 'success')
            this.updateView()
            this.$store.commit('setAjaxRequestPending', false)
            this.resetControlFormChanges()
          } else {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/orgprovinces' })
    },
    downloadData: async function (id) {
      let data = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idOrganismoProvincia: id
        }
        data = await getOrgProvince(params)
        this.setOrganismoProvincia(data.respuesta)
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return data
    },
    setOrganismoProvincia: function (data) {
      this.form.id = data.idOrganismoProvincia
      this.form.clienteId = data.idCliente
      
      setTimeout(() => {
        if (data.Organismos) {
          data.Organismos.forEach(x => {
            this.organismos.push(
              { 
                id: x.idOrganismo, 
                value: x.Nombre,
                label: this.formatNombreOrg(x),
              }
            )
          })
          
          setTimeout(() => {
            this.form.Organismo = data.Organismos.map(x => x.idOrganismo)
            this.resetControlFormChanges()
          }, 200)
        }
      }, 200)

      this.form.CodigoOrganismo = data.CodigoOrganismo
      this.form.NombreOrganismo = data.NombreOrganismo
      this.form.CodigoProvincia = data.CodigoProvincia
      this.form.NombreProvincia = data.NombreProvincia

      setTimeout(() => {
        this.loadingFirstTime = false
      }, 100)
      this.resetControlFormChanges()
    },
    updateView: function () {
      this.header.breadcrumb[2].name = `${this.form.NombreOrganismo} - ${this.form.NombreProvincia}`
      this.$store.commit('app/setheaderBreadCrumb', `${this.form.NombreOrganismo} - ${this.form.NombreProvincia}`)
    },
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
